import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { Eventcalendar, setOptions } from '@mobiscroll/react';
import React, { useMemo, useCallback, useState } from 'react';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import faTruck from "../../../../assets/images/truck-solid.svg";
import usrImg from "../../../../assets/images/user.jpg";
import { useEffect } from 'react';
import moment from 'moment';
import { guid } from '@progress/kendo-react-common';
import { Card, Grid, Box, Typography, ButtonGroup, Button, Checkbox,IconButton } from "@mui/material";
import Movements from '../../pages/Movements/Movements';
import TripRoutes from '../../pages/TripRoutes/TripRoutes';
import PartialTrip from '../../pages/PartialTrip/PartialTrip';

setOptions({
  theme: 'ios',
  themeVariant: 'light'
});

function AgendaMsPlayGround() {

  const now = new Date();
  var tommorow = new Date();
  let tmpEventData = [
    {
        id: 1,
        start: '2024-04-01T00:00',
        end: '2024-04-04T00:00',
        title: 'Event 1',
        resource: 1,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001269",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "08:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "ALEX RIPHAGEN",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 30000,
        "actionCode": "LOAD",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0001943",
        "addressname": "DE ZEESTERRE DAGBLADHANDEL",
        "address": "TORHOUTSESTEENWEG 169",
        "address2": "",
        "postCode": "8400",
        "city": "OOSTENDE",
        "sequenceNo": 1,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "08:00:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 0,
        "actionDurationHM": 1,
        "distance": 0,
        "driveDurationHM": 0,
        "restDurationHM": 0,
        "drivingState": "Default",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": false,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001269",
        "auxiliaryIndex3": 10000
    },
    {
        id: 2,
        start: '2024-04-03T00:00',
        end: '2024-04-05T00:00',
        title: 'Event 2',
        resource: 1,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001269",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "08:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "ALEX RIPHAGEN",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 40000,
        "actionCode": "LOAD",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0001942",
        "addressname": "DELTAREFERENCE B.V.B.A.",
        "address": "VISSERIJ 43 A",
        "address2": "",
        "postCode": "9000",
        "city": "GENT",
        "sequenceNo": 2,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "09:30:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 0.3,
        "actionDurationHM": 1,
        "distance": 70,
        "driveDurationHM": 1.11,
        "restDurationHM": 0,
        "drivingState": "Connection",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": false,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001269",
        "auxiliaryIndex3": 10000
    },
    {
      id: 3,
        start: '2024-04-06T00:00',
        end: '2024-04-08T00:00',
        title: 'Event 3',
        resource: 2,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001269",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "08:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "ALEX RIPHAGEN",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 60000,
        "actionCode": "UNLOAD",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0001948",
        "addressname": "ELNOR MOTORS",
        "address": "DECOSTERSTRAAT 45",
        "address2": "",
        "postCode": "3150",
        "city": "HAACHT",
        "sequenceNo": 3,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "13:00:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 2.3,
        "actionDurationHM": 1,
        "distance": 86,
        "driveDurationHM": 1.35,
        "restDurationHM": 0,
        "drivingState": "Connection",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": false,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001269",
        "auxiliaryIndex3": 10000
    },
    {
        id:4,
        resource: 1,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001269",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "08:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "ALEX RIPHAGEN",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 70000,
        "actionCode": "UNLOAD",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0001949",
        "addressname": "ECOMOB N.V.",
        "address": "KRAANLEI 45A",
        "address2": "",
        "postCode": "9000",
        "city": "GENT",
        "sequenceNo": 4,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "14:30:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 0.3,
        "actionDurationHM": 1,
        "distance": 87,
        "driveDurationHM": 1.39,
        "restDurationHM": 0,
        "drivingState": "Connection",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": false,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001269",
        "auxiliaryIndex3": 10000
    },
    {
      id:5,
      resource: 1,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001276",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "17:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 10000,
        "actionCode": "HOOKON",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0000048",
        "addressname": "PATISSERIE M. DE VOS",
        "address": "GENTSESTRAAT 147",
        "address2": "",
        "postCode": "9300",
        "city": "AALST",
        "sequenceNo": 1,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "17:00:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 0,
        "actionDurationHM": 0.15,
        "distance": 0,
        "driveDurationHM": 0,
        "restDurationHM": 0,
        "drivingState": "Default",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": true,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001276",
        "auxiliaryIndex3": 10000
    },
    { 
      id:6,
      resource: 1,
        "planGroupCode": "VEHICLES",
        "resourceNo": "VEH-00009",
        "resourcePlanDepartment": "",
        "resourcePlanSubdepartment": "",
        "tripNo": "T001276",
        "partialtripLineNo": 10000,
        "ptStartingDate": now.setHours(0, 0, 0, 0),
        "startTime": "17:00:00",
        "ptEndingDate": now.setHours(0, 0, 0, 0),
        "inManualMode": false,
        "changingSeq": "",
        "planDepartment": "HARELBEKE",
        "planSubdepartment": "NAT",
        "ptStatus": "10",
        "splitMethod": " ",
        "emptyTrip": false,
        "routeLineNo": 20000,
        "actionCode": "UNLOAD",
        "county": "",
        "country": "BE",
        "addresscode": "ADR-0001923",
        "addressname": "NERVIA PLASTICS B.V.B.A.",
        "address": "FONTEINSTRAAT 55",
        "address2": "",
        "postCode": "9400",
        "city": "OKEGEM",
        "sequenceNo": 2,
        "startingDate": now.setHours(0, 0, 0, 0),
        "startingTime": "20:00:00",
        "trailer": "TRL-00006",
        "driver": "E0140",
        "vehicle": "VEH-00009",
        "durationHM": 2.45,
        "actionDurationHM": 1,
        "distance": 13,
        "driveDurationHM": 0.21,
        "restDurationHM": 0,
        "drivingState": "Manual",
        "dummyAction": false,
        "hideDummyAction": false,
        "chassis": "",
        "fixedActionTime": true,
        "status": "10",
        "auxiliaryIndex1": "",
        "auxiliaryIndex2": "T001276",
        "auxiliaryIndex3": 10000
    }
]
const categories = ["Trip", "Action"];
  const [myEvents, setmyEvents] = useState(tmpEventData)
  const [eventsData, seteventsData] = useState(tmpEventData)
  const [selectedCategory, setselectedCategory] = useState("Trip")
  const [myConnections, setmyConnections] = useState([
    {
      from: 1,
      to: 2,
      color: 'green',
      arrow: 'to',
    },
    {
      from: 2,
      to: 3,
      color: 'orange',
      arrow: 'to',
    },
    {
      from: 3,
      to: 4,
      color: 'olive',
      arrow: 'to',
    },
    {
      from: 5,
      to: 4,
      color: 'blue',
      arrow: 'bidirectional',
      cssClass: 'dashed-line',
    },
    {
      from: 6,
      to: 8,
      color: 'black',
      arrow: 'from',
    },
    {
      from: 7,
      to: 6,
      color: 'purple',
      arrow: false,
    },
    {
      from: 8,
      to: 10,
      color: 'green',
      arrow: false,
    },
    {
      from: 9,
      to: 12,
      color: 'brown',
      arrow: 'from',
    },
    {
      from: 10,
      to: 9,
      color: 'red',
      arrow: false,
    },
    {
      from: 10,
      to: 11,
      color: 'orange',
      arrow: 'bidirectional',
    },
    {
      from: 12,
      to: 14,
      color: 'pink',
      arrow: 'to',
    },
  ])
  // const myEvents = useMemo(
  //   () => [
      // {
      //   id: 1,
      //   start: '2024-04-01T00:00',
      //   end: '2024-04-04T00:00',
      //   title: 'Event 1',
      //   resource: 1,
      // },
      // {
      //   id: 2,
      //   start: '2024-04-03T00:00',
      //   end: '2024-04-05T00:00',
      //   title: 'Event 2',
      //   resource: 1,
      // },
      // {
      //   id: 3,
      //   start: '2024-04-06T00:00',
      //   end: '2024-04-08T00:00',
      //   title: 'Event 3',
      //   resource: 2,
      // },
      // {
      //   id: 4,
      //   start: '2024-04-06T00:00',
      //   end: '2024-04-09T00:00',
      //   title: 'Event 4',
      //   resource: 2,
      // },
      // {
      //   id: 5,
      //   start: '2024-04-09T00:00',
      //   end: '2024-04-11T00:00',
      //   title: 'Event 5',
      //   resource: 3,
      // },
      // {
      //   id: 6,
      //   start: '2024-04-10T00:00',
      //   end: '2024-04-12T00:00',
      //   title: 'Event 6',
      //   resource: 3,
      // },
  //     {
  //       id: 7,
  //       start: '2024-04-13T00:00',
  //       end: '2024-04-16T00:00',
  //       title: 'Event 7',
  //       resource: 4,
  //     },
  //     {
  //       id: 8,
  //       start: '2024-04-14T00:00',
  //       end: '2024-04-17T00:00',
  //       title: 'Event 8',
  //       resource: 4,
  //     },
  //     {
  //       id: 9,
  //       start: '2024-04-18T00:00',
  //       end: '2024-04-20T00:00',
  //       title: 'Event 9',
  //       resource: 5,
  //     },
  //     {
  //       id: 10,
  //       start: '2024-04-19T00:00',
  //       end: '2024-04-22T00:00',
  //       title: 'Event 10',
  //       resource: 5,
  //     },
  //     {
  //       id: 11,
  //       start: '2024-04-22T00:00',
  //       end: '2024-04-26T00:00',
  //       title: 'Event 11',
  //       resource: 6,
  //     },
  //     {
  //       id: 12,
  //       start: '2024-04-24T00:00',
  //       end: '2024-04-28T00:00',
  //       title: 'Event 12',
  //       resource: 6,
  //     },
  //   ],
  //   [],
  // );

  const myView = {
    timeline: {
      type: 'week',
      startDay: 1,
      endDay: 15,
      startTime: '00:00',
      endTime: '24:00',
      timeCellStep: 30,
      timeLabelStep: 60,
      weekNumbers: true,
      currentTimeIndicator: true
    },
  };

  const myResources = useMemo(
    () => [
      {
        id: 1,
        name: 'VH-479-DB',
        color: '#fdf500',
      },
      {
        id: 2,
        name: 'VH-454-SJ',
        color: '#ff4600',
      },
      {
        id: 3,
        name: 'VH-875-LC',
        color: '#ff0101',
      },
      {
        id: 4,
        name: 'VH-147-DW',
        color: '#239a21',
      },
      {
        id: 5,
        name: 'VH-943-PA',
        color: '#8f1ed6',
      },
      {
        id: 6,
        name: 'VH-287-ME',
        color: '#01adff',
      },
    ],
    [],
  );
  
  const onCategoryChange = (e)=>{
    console.log(e)
    setselectedCategory(e.value)
    parseEventData(e.value)
  }

  useEffect(() => {
    parseEventData("Action")
    tmpEventData.forEach(event =>{
      const [hours, minutes, seconds] = event.startingTime.split(":").map(Number);
      const [endHours, endMinutes, endSeconds] = event.startingTime.split(":").map(Number);
      event.start = new Date(event.startingDate).setHours(hours, minutes, seconds)
      event.end =  new Date(event.startingDate).setHours((new Date(event.start).getHours()+1),15,0)
      event.resource = 1
    })
    seteventsData(tmpEventData)
    console.log("eventsData",eventsData)
    addResizeHandler()
  }, [])
  const parseEventData = (flag)=>{
    if(flag == "Trip"){
      var data = Object.groupBy(eventsData, ({ tripNo }) => tripNo)
      var groupedDataArray =[];
      for (const [key, value] of Object.entries(data)) {        
        const endIndex = value.length-1
        const [hours, minutes, seconds] = value[0].startingTime.split(":").map(Number);
        const [endHours, endMinutes, endSeconds] = value[endIndex].startingTime.split(":").map(Number);
        groupedDataArray.push({
          tripNo: key,
          data: value,
          start: new Date(value[0].startingDate).setHours(hours, minutes, seconds),
          end: new Date(value[endIndex].startingDate).setHours(endHours, endMinutes, endSeconds),
          resource:1,
          id:guid()
        })         
      }
      console.log(groupedDataArray);
      setmyEvents(groupedDataArray)             
    }
    else if(flag == "Action"){
      console.log("setmyEvents(eventsData)",eventsData)
      console.log("myEvents",myEvents)
      let connection = []
      myEvents.forEach(trip=>{
        trip?.data?.slice(0, -1).map((item, index) => {
          // if(item.actionCode=='LOAD'){
          //   connection.push({
          //     from: item.id,
          //     to: trip.data[index + 1].id,
          //     color: "black",
          //     arrow: "",
          //     cssClass:""
          //   })
          // }
          connection.push({
          from: item.id,
          to: trip.data[index + 1].id,
          color: item.actionCode=='LOAD'?"gray":'sandybrown',
          arrow: "",
          cssClass:item.actionCode=='LOAD'?"dashed-line":''
        })
        });        
      })
      setmyConnections(connection)
      setmyEvents(eventsData)
    }
  }
  const addResizeHandler=()=>{
    setTimeout(()=>{
      const resources = document?.getElementsByClassName('mbsc-timeline-resource');
      const timelineGrid = document?.getElementsByClassName('mbsc-timeline-grid')[0];
      let reactFiberKey = null;

      const observer = new ResizeObserver((entries) => {
        if (!reactFiberKey && entries.length > 0) {
          // Find the react fiber key once
          reactFiberKey = Object.keys(entries[0].target).find(key => key.startsWith('__reactFiber$'));
        }

        entries.forEach(entry => {
          const key = entry?.target?.[reactFiberKey]?.key;
          if (key && entry) {
            const timelineRow = timelineGrid?.getElementsByClassName('mbsc-timeline-row')[+key - 1];
            if (timelineRow) {
              // Use requestAnimationFrame to defer the style change
              requestAnimationFrame(() => {
                timelineRow.style.minHeight = `${entry.contentRect.height}px`;
              });
            }
          }
        });
      });

      Array.from(resources).forEach((r) => {
        observer.observe(r);
      });

      return () => {
        Array.from(resources).forEach((r) => {
          observer.unobserve(r);
        });
        observer.disconnect();
      };

    },1000)   
  }
  
  const customScheduleEvent = useCallback((data) => {
    // console.log(data.style)       
    return (
      <div className={`md-custom-event-cont ${data.original.actionCode=='LOAD'&&'event-wraper'}`}      style={{background:'#64c6bb',color:'#000'}}>
        <div className="md-custom-event-wrapper" style={{ padding: '5px' }}>
          <div className="md-custom-event-details" style={{display:'flex', alignItems:'center'}}>
            <img src={usrImg} style={{ height: "15px", width: "15px", borderRadius: "50%" ,verticalAlign:'middle', marginRight:'5px'}} alt="user" /> 
              <img src={faTruck} style={{ height: "15px", width: "15px",verticalAlign:'middle',marginRight:'5px' }} alt="vehicle" /> 
            <div className="md-custom-event-title font12" style={{fontWeight:'bold',paddingRight: '8px'}}>{data.original.tripNo}</div>           
          </div>
          {data.original.actionCode && <div className="md-custom-event-title font12" style={{fontWeight:'bold',paddingRight: '8px'}}>{data.original.actionCode}</div>           }
          <div className="md-custom-event-time font12">
          <div style={{ display: 'flex' }}>
                {/* {data.original.data.length>1 && 
                (<>{data.original.data[0].actionCode} [{data.original.data[0].city}]<div style={{ border: "1px solid #014b43", width: '100px', margin: '5px 10px', background: '#0a7367', padding: '1px 5px', textAlign: 'center' }}></div>{data.original.data[data.original.data.length -1].actionCode} [{data.original.data[data.original.data.length -1].city}]</>)}                 */}
                {/* <div style={{ border: "1px solid #014b43", width: '100px', margin: '5px 100px', background: '#0a7367', padding: '1px 5px', textAlign: 'center' }}></div> */}
                {selectedCategory=="Trip" && data?.original?.data?.length >0 && data?.original?.data
                .map((action,index) => (<>{action.actionCode} [{action.city}]{index!= data.original.data.length-1 &&<div style={{ border: "1px solid #014b43", width: '100px', margin: '5px 10px', background: '#0a7367', padding: '1px 5px', textAlign: 'center' }}></div>}</>))}
              </div>
              {data.start} - {data.end}              
            </div>
        </div>
      </div>
    );
  }, []);
  return (
    <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 0, mt: 1, ml: 1, width: '100%',overflow:'scroll'}} className="filterbar-bg " onContextMenu={(e) => {e.preventDefault()}}>

      <form className="k-form" onSubmit={(e) => e.preventDefault()}>
          <fieldset>
            <div>Choose category</div>
            <DropDownList
              style={{
                width: "300px",
              }}
              data={categories}
              defaultValue={selectedCategory}
              onChange={onCategoryChange}
            />
          </fieldset>
        </form>       
        <Box sx={{ p: 0, display: 'flex', }} className=''>
      <Eventcalendar
        clickToCreate={true}
        dragToCreate={true}
        dragToMove={true}
        dragToResize={true}
        eventDelete={true}
        view={myView}
        data={myEvents}
        resources={myResources}
        connections={myConnections}
        renderScheduleEvent={customScheduleEvent}
        
      /></Box>
      <div style={{display:'flex'}}>
        <div style={{width:'50%',height:'250px',overflow:'scroll'}}><TripRoutes/></div>                            
        <div style={{width:'50%',height:'250px',overflow:'scroll'}}><Movements/></div>        
      </div>   
     </Grid>
  );
}

export default AgendaMsPlayGround;